import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './styles.css';

/**
 * 触屏机入口。
 *
 * 这里刻意不做的事情：
 *   · 不注册任何「未登录跳转」—— 触屏机本来就没有登录态；
 *   · 不加载任何在线资源（字体、CDN、二维码服务）—— 门店可能没外网；
 *   · 不引入 Pinia 之类的状态库 —— 一台机器一份状态，够用就好。
 */
const app = createApp(App);
app.use(router);

/**
 * 扫桌码进来的（table 模式）直接落到点餐页。
 *
 * 为什么：一体机上需要「欢迎页 → 点开始点餐」是因为机器是公用的，
 * 得有人明确表示"我要点餐"。而顾客扫自己桌上的码进来，意图已经很明确了，
 * 再让他点一次「开始点餐」纯属多余。欢迎页和空闲清空都是**一体机专属**行为。
 */
import { kiosk } from './stores/kiosk';
if (kiosk.state.config.mode === 'table' && router.currentRoute.value.path === '/') {
  void router.replace('/menu');
}

app.mount('#app');
